import { format } from 'date-fns'

export default function (value, dateFormat = 'YYYY. MM. D. H:mm') {
  return value ? format(value, dateFormat) : ''
}



// WEBPACK FOOTER //
// ./src/filters/date.js